/**
 * Утилита для отправки целей в системы аналитики
 */

/**
 * Отправка события в CarrotQuest
 * @param {string} eventName - Название события (до 255 символов)
 * @param {object} params - Дополнительные параметры (ключи до 70 символов, значения: строка, число, дата, массив, boolean)
 */
export const sendCarrotQuestEvent = (eventName, params = {}) => {
  if (!process.browser) return;

  try {
    // CarrotQuest создает обертки для методов сразу при инициализации
    // Если CarrotQuest загружен - вызов выполнится сразу
    // Если еще не загружен - вызов попадет в очередь через обертку
    if (window.carrotquest && typeof window.carrotquest.track === 'function') {
      window.carrotquest.track(eventName, params);
    }
  } catch (error) {
    console.warn('Ошибка отправки события в CarrotQuest:', error);
  }
};
